<ion-item-divider sticky>
  @if (infiniteScrollConfig().icon) {
    <ion-icon
      slot="start"
      aria-hidden="true"
      [src]="infiniteScrollConfig().icon"
    ></ion-icon>
  }
  <div class="header-scroll-container">
    @if (infiniteScrollConfig().text) {
      <div class="subtitle">{{ infiniteScrollConfig().text }}</div>
    }

    @if (infiniteScrollConfig().appliedFilters?.length) {
      <div class="applied-filters">
        @for (filter of infiniteScrollConfig().appliedFilters; track filter.label) {
          <ion-chip
            [outline]="true"
            (click)="filter.clear()"
          >
            <ion-label>{{ filter.label }}</ion-label>
            <ion-icon
              aria-hidden="true"
              src="../assets/material-symbols/close_24dp.svg"
            ></ion-icon>
          </ion-chip>
        }
      </div>
    }

    @if (infiniteScrollConfig().refreshButton && infiniteScrollConfig().staleMessage) {
      <div class="fs-xs">{{ infiniteScrollConfig().staleMessage }}</div>
    }
  </div>
  @if (infiniteScrollConfig().lastUpdated) {
    <p
      class="fs-xs ion-text-end"
      slot="end"
    >
      {{ 'general.last_updated' | translate }} {{ infiniteScrollConfig().lastUpdated | date: 'HH:mm' }}h
    </p>
  }
  @if (infiniteScrollConfig().refreshButton) {
    <ion-button
      slot="end"
      size="small"
      fill="outline"
      (click)="infiniteScrollConfig().refreshButton!.action()"
    >
      {{ infiniteScrollConfig().refreshButton!.label }}
    </ion-button>
  }
</ion-item-divider>
